import React, { useLayoutEffect, useMemo, useState } from "react";
import { gsap } from "gsap";
import { Link } from "react-router-dom";
const connectorCategories = [
  {
    id: 1,
    name: "Marketing",
    connectors: [
      {
        image: require("../../assets/images/connectors/google_analytics.png"),
      },
      {
        image: require("../../assets/images/connectors/facebook.png"),
      },
      {
        image: require("../../assets/images/connectors/google_play.png"),
      },
      {
        image: require("../../assets/images/connectors/google_ads.png"),
      },
      {
        image: require("../../assets/images/connectors/bing_ads.png"),
      },
      {
        image: require("../../assets/images/connectors/sendgrid.png"),
      },
      {
        image: require("../../assets/images/connectors/mailchimp.png"),
      },
      {
        image: require("../../assets/images/connectors/shopify.png"),
      },
      {
        image: require("../../assets/images/connectors/instagram.png"),
      },
      {
        image: require("../../assets/images/connectors/linkedIn_ads.png"),
      },
      {
        image: require("../../assets/images/connectors/typeform.png"),
      },
      {
        image: require("../../assets/images/connectors/marketo.png"),
      },
    ],
  },
  {
    id: 2,
    name: "Product",
    connectors: [
      {
        image: require("../../assets/images/connectors/amplitude.png"),
      },
      {
        image: require("../../assets/images/connectors/mixpanel.png"),
      },
      {
        image: require("../../assets/images/connectors/posthog.png"),
      },
      {
        image: require("../../assets/images/connectors/ortto.png"),
      },
      {
        image: require("../../assets/images/connectors/uservoice.png"),
      },
      {
        image: require("../../assets/images/connectors/airship.png"),
      },
      {
        image: require("../../assets/images/connectors/referral_saasquatch.png"),
      },
      {
        image: require("../../assets/images/connectors/pendo.png"),
      },
      {
        image: require("../../assets/images/connectors/fullstory.png"),
      },
      {
        image: require("../../assets/images/connectors/heap.png"),
      },
      {
        image: require("../../assets/images/connectors/outbrain.png"),
      },
      {
        image: require("../../assets/images/connectors/front.png"),
      },
    ],
  },
  {
    id: 3,
    name: "Sales & Support",
    connectors: [
      {
        image: require("../../assets/images/connectors/salesforce.png"),
      },
      {
        image: require("../../assets/images/connectors/hubspot.png"),
      },
      {
        image: require("../../assets/images/connectors/freshdesk.png"),
      },
      {
        image: require("../../assets/images/connectors/intercom.png"),
      },
      {
        image: require("../../assets/images/connectors/pipedrive.png"),
      },
      {
        image: require("../../assets/images/connectors/close.png"),
      },
      {
        image: require("../../assets/images/connectors/dixa.png"),
      },
      {
        image: require("../../assets/images/connectors/drift.png"),
      },
      {
        image: require("../../assets/images/connectors/help_scout.png"),
      },
      {
        image: require("../../assets/images/connectors/outreach.png"),
      },
      {
        image: require("../../assets/images/connectors/mailshake.png"),
      },
      {
        image: require("../../assets/images/connectors/liveperson.png"),
      },
    ],
  },
  {
    id: 4,
    name: "Finance & Ops",
    connectors: [
      {
        image: require("../../assets/images/connectors/stripe.png"),
      },
      {
        image: require("../../assets/images/connectors/square.png"),
      },
      {
        image: require("../../assets/images/connectors/paypal.png"),
      },
      {
        image: require("../../assets/images/connectors/quickbooks.png"),
      },
      {
        image: require("../../assets/images/connectors/chargbee.png"),
      },
      {
        image: require("../../assets/images/connectors/workday_raas.png"),
      },
      {
        image: require("../../assets/images/connectors/bamboohr.png"),
      },
      {
        image: require("../../assets/images/connectors/xero.png"),
      },
      {
        image: require("../../assets/images/connectors/zuora.png"),
      },
      {
        image: require("../../assets/images/connectors/plaid.png"),
      },
      {
        image: require("../../assets/images/connectors/recurly.png"),
      },
      {
        image: require("../../assets/images/connectors/invoiced.png"),
      },
    ],
  },
];

const HomeConnector = ({heading, subHeading}) => {
  const [selected, setSelected] = useState(1);
  const { connectors } = useMemo(
    () => connectorCategories.filter((category) => category.id === selected)[0],
    [selected]
  );

  useLayoutEffect(() => {
    gsap.fromTo(
      ".connector-images",
      { opacity: 0, y: "1rem" },
      {
        opacity: 1,
        y: "0rem",
        scrollTrigger: {
          trigger: ".home__connector",
          start: "top 70%",
          // scrub: 1
        },
      }
    );
  }, [selected]);
  return (
    <div className="home__connector">
      <div className="container">
        <div className="left reveal-from-left">
          <div className="Hconnector__tag text__tag">elt</div>
          <div className="Hconnector__heading text__heading">
            {heading}
          </div>
          <div className="Hconnector__sub  text__sub">
            {subHeading}
          </div>
          <Link to="/onestack-data/connectors">
          <button className="button__main button__primary">
            Explore More Connectors{" "}
            <img
              src={require("../../assets/images/long-arrow-right.svg")}
              alt="arrow"
            />
          </button>
          </Link>
        </div>
        <div className="right">
          <div className="connector-tiles">
            {connectorCategories.map((category) => {
              return (
                <div
                  className={`tile ${
                    category.id === selected ? "selected" : ""
                  }`}
                  key={category.id}
                  onClick={() => setSelected(category.id)}
                >
                  {category.name}
                </div>
              );
            })}
          </div>
          <div className="connector-images">
            {connectors.map((connector, index) => {
              return (
                <div className="connector-logo" key={index}>
                  <img src={connector.image} alt="connector_logo" />
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

export default HomeConnector;
